import SummaryService from '@/api/SummaryService.js'
import Vue from 'vue'
export const summaryModule = {
  namespaced: true,
  state: () => ({
    summaryData: {},
    summaryLoadStatus: 'request'
  }),

  getters: {},
  mutations: {
    get(state, data) {
      if (data.length) state.summaryData = data[0]
    },

    load_request(state, status) {
      state.finesLoadStatus = 'request'
    },
    load_success(state) {
      state.finesLoadStatus = 'success'
    },
    load_error(state) {
      state.finesLoadStatus = 'error'
    }
  },
  actions: {
    getSummaryAll({ commit }, params) {
      commit('load_request')

      SummaryService.get(params)
        .then((data) => {
          commit('get', data.data.data)
          commit('load_success')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
          commit('load_error')
        })
    }
  }
}
